import { useCallback } from "react";

import useGoogleTagManager from "../../../../../hooks/useGTM";

export function useProductDetailsClick(navigate: (id: number) => void) {
  const { interactionEvent } = useGoogleTagManager();

  return useCallback(
    (planName: string, id: number) => {
      interactionEvent({
        event_action: "clicou",
        event_category: "catalogo_planos_home",
        event_label: "conheca_ja",
        event_name: "ver_detalhes_do_produto",
        select_item: planName,
      });

      navigate(id);
    },
    [interactionEvent, navigate]
  );
}
